import React from 'react'
import { Button } from 'reactstrap';
import { FormSendCSV } from './FormSendCSV';
import { Dialog } from 'primereact/dialog';
import { FileUpload } from 'primereact/fileupload';

export const ModalSendCSV = (props) => {

    const {

        modal2, method2, modalTitle2, loading, toggle2, file, handleInputChange, handleOnChange,
        ExamIndication,


    } = props;
    const footer = (
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
                color="danger"
                size="sm"
                className="finalizar-btn"
                onClick={toggle2}
            // style={{ height: "31px", width: "85px" }}
            >
                Cancelar
            </Button>
        </div>
    );

    return (

        <Dialog
            // header={modalTitle2}
            visible={modal2}
            onHide={toggle2}
            modal
            //className="medium-dialog"
            // maskClassName="medium-dialog-mask"
            footer={footer}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="pi pi-upload "></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle2}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v22`}
            closable={false}
        >
            <br /> <br />
            <div className="upload-zone-modern ">
                <FileUpload
                    name="csvFile"
                    customUpload
                    uploadHandler={(e) => ExamIndication(e)}

                    onSelect={handleOnChange}

                    accept=".csv"

                    maxFileSize={2000000}

                    headerTemplate={(options) => {
                        const { chooseButton, uploadButton } = options;

                        return (
                            <div className="custom-header">
                                <div className="left-buttons">
                                    {chooseButton}
                                    {uploadButton}
                                </div>
                            </div>
                        );
                    }}

                    itemTemplate={(file, props) => (

                        <div className="custom-file-card">

                            <div className="file-info">
                                <div className="file-name">
                                    {file.name}
                                </div>

                                <div className="file-status">
                                    Listo para procesar
                                </div>
                            </div>

                            <button
                                className="delete-btn"
                                type="button"
                                onClick={() => props.onRemove(file)}
                            >
                                <i className="pi pi-trash"></i>
                            </button>

                        </div>

                    )}

                    chooseLabel="Seleccionar CSV"
                    uploadLabel="Subir"

                    className="modern-upload"
                />
            </div>

        </Dialog>


        //     <Modal isOpen={modal2} toggle={toggle2}  backdrop='static' keyboard={false} centered={true} >
        //     <ModalHeader toggle={toggle2}  className="bg-primary">
        //         {modalTitle2}
        //     </ModalHeader>
        //     {
        //         method2 === "listCSV"
        //             ? <FormSendCSV
        //                 button="Guardar"
        //                 {...{  modal2, method2, modalTitle2,loading,toggle2,file,handleInputChange,
        //                     handleOnChange,methodAction:ExamIndication}}
        //             />
        //             : (method2 === "update")       
        //     }
        // </Modal>

    )
}
